import ChannelInterface from "@/interfaces/channel.interface";
import axiosSaysimple from "@/libs/axios";
import { MetaSignupResponse } from "@/types/embeddedSignup.types";
import { Ref, ref } from "@vue/composition-api";
import router from "@/router";

export default function useEmbeddedSignup() {
    const isSignupInProgress: Ref<boolean> = ref(false); // When the popup is open, so the signup started.
    const isSetupInProgress: Ref<boolean> = ref(false); // When the setup with Meta and creating configuration etc is in progress.
    const wabaId = ref<string>();
    const phoneNumberId = ref<string>();

    const initMetaSdk = () => {
        // @ts-ignore
        window.fbAsyncInit = function () {
            // @ts-ignore
            FB.init({
                appId: process.env.VUE_APP_META_APP_ID,
                autoLogAppEvents: true,
                xfbml: true,
                version: "v22.0",
            });
        };

        (function (d, s, id) {
            let js;
            const fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) return;
            //eslint-disable-next-line prefer-const
            js = d.createElement(s);
            js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        })(document, "script", "facebook-jssdk");
    };

    const launchWhatsAppSignup = (callback: (error: boolean | string, data?: any) => void) => {
        isSignupInProgress.value = true;

        // @ts-ignore
        FB.login(
            (response: MetaSignupResponse) => {
                isSetupInProgress.value = true;

                // @Debug mock data
                //response = {
                //    authResponse: {
                //        code: "123456",
                //        expiresIn: null,
                //        userID: null,
                //    },
                //    status: "unknown",
                //};
                if (response.authResponse) {
                    if (!wabaId.value || !phoneNumberId.value) {
                        isSetupInProgress.value = false;
                        return;
                    }

                    axiosSaysimple
                        .post(`/channels/embedded-signup`, {
                            code: response.authResponse.code,
                            wabaId: wabaId.value,
                            phoneNumberId: phoneNumberId.value,
                        })
                        .then(({ data }: { data: ChannelInterface }) => {
                            callback(false, data);
                            router.go(0); // refresh the page. Bit hardcore, but the reactivity of the channels overview made it hard to update the list for now.
                        })
                        .catch((err) => {
                            callback(`Could not setup WhatsApp: ${err.response?.data.message}`);
                        });
                } else {
                    // When invalid or popup has been closed.
                    callback(true);
                }

                isSignupInProgress.value = false;
                isSetupInProgress.value = false;
            },
            {
                config_id: process.env.VUE_APP_META_CONFIG_ID,
                response_type: "code",
                override_default_response_type: true,
                extras: {
                    setup: {},
                    featureType: "",
                    sessionInfoVersion: "3",
                },
            }
        );
    };

    return {
        initMetaSdk,
        isSetupInProgress,
        isSignupInProgress,
        launchWhatsAppSignup,
        phoneNumberId,
        wabaId,
    };
}
